import React, {
  useState,
  useEffect,
  type ReactNode,
  useCallback,
  useContext,
} from "react";
import { NotificationsContext } from "./NotificationsContext";
import api from "../../../api/api";
import type {
  IGetNotificationsParams,
  IGetNotificationsResponse,
} from "../../types/notifications.types";
import { AuthContext } from "../Auth/AuthContext";

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationsProvider: React.FC<NotificationProviderProps> = ({
  children,
}) => {
  const { isLoggedIn } = useContext(AuthContext);
  const [noReadNotificationsLength, setNoReadNotificationsLength] = useState(0);
  const [notifications, setNotifications] =
    useState<IGetNotificationsResponse | null>(null);
  const revalidateNotifications = useCallback(
    async (params: IGetNotificationsParams) => {
      if (!isLoggedIn) return;
      try {
        const result = await api.getNotifications(params);
        setNoReadNotificationsLength(result.unreadCount);
        setNotifications(result);
        return result;
      } catch (error) {
        console.error("Notifications fetch failed:", error);
        setNoReadNotificationsLength(0);
      }
    },
    []
  );

  useEffect(() => {
    revalidateNotifications({});
    const interval = setInterval(revalidateNotifications, 30 * 1000);
    return () => clearInterval(interval);
  }, [revalidateNotifications]);

  return (
    <NotificationsContext.Provider
      value={{
        noReadNotificationsLength,
        setNoReadNotificationsLength,
        notifications,
        setNotifications,
        revalidateNotifications,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};
